export enum weaponType {
  PISTOLS = 'PISTOLS',
  SHOTGUN = 'SHOTGUN',
}

export function getWeaponTypeKeyByValue(

  enumValue: string
): string {
  let keys = Object.keys(weaponType).filter((x) => weaponType[x] == enumValue);
  return keys.length > 0 ? keys[0] : '';
}
